import React from 'react'
import CustomBtn from './CustomButton'
import Grid from '@material-ui/core/Grid';
import Name from '../TrueNorthName.png'
import Logo from '../TrueNorthLogo.png'
import Hidden from '@material-ui/core/Hidden';
import DrawerMenu from './DrawerMenu';
import { Route, Link, BrowserRouter as Router } from 'react-router-dom';



class CustomNavbar extends React.Component {
constructor(props) {
    super(props);

}

render() {

    let topLogo;
    let topName;

    if(this.props.logo){
        topLogo = (
            <img src={Logo} style={{maxHeight: '50px', margin:'5px 5px', zIndex:'1'}}/>
        );
        topName = (
            <img src={Name} style={{maxWidth: '220px', margin:'5px 5px', zIndex:'1'}}/>
        );
    }
    
    return( 
    <Grid container spacing={0}>
        <Hidden mdUp>
            <Grid container direction="row" justify={'flex-start'} alignItems={'center'}style={{padding:'0px 10px',zIndex:1}}>
                <DrawerMenu app={this}></DrawerMenu>
                {topLogo}
                {topName} 
            </Grid>
        </Hidden>
        <Hidden smDown>
            <Grid container direction="row" justify={'center'} alignItems={'center'}style={{padding:'0px 20px',zIndex:1}}>
                {topLogo}
                {topName}       
                <div style={{flexGrow:1}}></div>
                <Link to="/" style={{textDecoration: 'none'}}><CustomBtn click={null} name={'Home'}></CustomBtn></Link>
                <Link to="/TrueNorthServer" style={{textDecoration: 'none'}}><CustomBtn click={null} name={'TrueNorth Server'}></CustomBtn></Link>
                <Link to="/TrueNorthGarmin" style={{textDecoration: 'none'}}><CustomBtn click={null} name={'TrueNorth Garmin App'}></CustomBtn></Link>
                <Link to="/Download" style={{textDecoration: 'none'}}><CustomBtn click={null} name={'Downloads'}></CustomBtn></Link>
                <Link to="/Contacts" style={{textDecoration: 'none'}}><CustomBtn click={null} name={'Contacts'}></CustomBtn></Link>
            </Grid>
        </Hidden>
    </Grid>
    )
  }
}

export default CustomNavbar